import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _get from 'lodash/get';
import _has from 'lodash/has';
import _map from 'lodash/map';
import _forEach from 'lodash/forEach';
import { Coupon } from 'commons/models/coupon';
import { EMPTY_ARRAY, EMPTY_OBJECT } from 'commons-ui';

import { TYPE_OPTIONS, ALLOWED_PAYMENT_MODES_OPTIONS } from './constants';

export const hydrateFormData = (data: any) => {
	const allowedPaymentModesIds = _map(ALLOWED_PAYMENT_MODES_OPTIONS, (option) => option.id);
	const typeIds = _map(TYPE_OPTIONS, (option) => option.id);

	const hydratedData = {
		...data,
		conversions: _map(
			Object.entries(_get(data, 'conversions', EMPTY_OBJECT)),
			([amount, conversion]: [amount: any, conversion: any]) => {
				const formConversion: any = { amount };
				_forEach(Object.entries(conversion), ([key, value]: [key: any, value: any]) => {
					formConversion[key] = parseInt(value, 10);
				});

				return formConversion;
			}
		),
		allowedPaymentModes: _filter(_get(data, 'allowedPaymentModes', EMPTY_ARRAY), (paymentMode) =>
			_includes(allowedPaymentModesIds, paymentMode)
		),
		type: _includes(typeIds, _get(data, 'type')) ? _get(data, 'type') : undefined
	};

	if (_has(hydratedData, 'id')) {
		delete hydratedData.id;
	}

	return hydratedData;
};

export const dehydrateFormData = (data: any): Coupon => {
	const { conversions: formConversions, maxConversionPerRedemption, allowUnlimitedRedemptions, type } = data;
	const conversions: any = {};

	_forEach(formConversions, (formConversion) => {
		const { amount } = formConversion;
		const conversion = { ...formConversion };
		delete conversion.amount;

		conversions[amount] = { bonusCoins: '0f', tickets: '0f' };

		_forEach(Object.entries(conversion), ([key, value]: [key: any, value: any]) => {
			conversions[amount][key] = `${value}f`;
		});
	});

	let maxRedemptions = _get(data, 'maxRedemptions');
	if (allowUnlimitedRedemptions) {
		maxRedemptions = Number.MAX_SAFE_INTEGER;
	}

	let { allowedPaymentModes, isFirstDeposit, isSecondDeposit } = data;
	if (type === 'PARTNER_COUPON_CASHLESS') {
		allowedPaymentModes = [];
		isFirstDeposit = false;
		isSecondDeposit = false;
	}

	const newData = {
		...data,
		conversions,
		maxRedemptions,
		maxRedemptionsPerPerson: maxRedemptions,
		maxConversionPerRedemption: { bonusCoins: 0, tickets: 0, ...maxConversionPerRedemption },
		sortOrder: Number.MAX_SAFE_INTEGER,
		isOpen: true,
		isHiddenFromApp: true,
		isPartnerCoupon: true,
		allowedPaymentModes,
		isFirstDeposit,
		isSecondDeposit
	};

	delete newData.allowUnlimitedRedemptions;
	delete newData.allowUnlimitedRedemptionsPerPerson;

	return newData;
};

export const dehydrateBulkFormData = (data: any): any => {
	const { isDisabled, maxRedemptions, validFrom, validTill, partnerName, quantity, cid, allowUnlimitedRedemptionsPerPerson } = data;

	let maxRedemptionsPerPerson = _get(data, 'maxRedemptionsPerPerson');

	if (allowUnlimitedRedemptionsPerPerson) {
		maxRedemptionsPerPerson = Number.MAX_SAFE_INTEGER;
	}

	const newData = {
		partnerName,
		quantity,
		cid,
		partnerCouponConfig: {
			isDisabled,
			maxRedemptions,
			maxRedemptionsPerPerson,
			validFrom,
			validTill
		}
	};

	return newData;
};
